import type { SessionHydration_Asset_Image, UnionImage } from '~/graphql/types';
import { assertNever } from '../assertion';

/**
 *
 * @param {UnionImage} image - The image to get the url for
 * @param {Array<SessionHydration_Asset_Image>} assetImages - The asset images to search in
 * @param {string | null} defaultImage - The default image to return if the image is not found
 * keywords: image url
 */
const getUnionImageUrl = (
  image: UnionImage | null | undefined,
  assetImages: Array<SessionHydration_Asset_Image>,
  defaultImage?: string | null,
): string | null => {
  const fallbackImage = defaultImage || null;
  if (!image) return fallbackImage;

  switch (image.__typename) {
    case 'DHImage':
      return image.url;
    case 'AssetImage':
      return (
        assetImages.find(({ id }) => id === image.assetId)?.url || fallbackImage
      );
    default:
      return assertNever(image);
  }
};

export default getUnionImageUrl;
